import { createContext, useContext } from 'react';

export type SearchContextValue = {
    query: string;
    onQueryChange: (query: string) => void;
};

export const SearchContext = createContext<SearchContextValue | undefined>(undefined);

export function useSearchContext(): SearchContextValue {
    const context = useContext(SearchContext);

    if (!context) {
        throw new Error('Search components must be used within <Search>');
    }

    return context;
}
